import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { placeholderImg } from "../../../Entryfile/imagepath";
import axios from "axios";
import swal from "sweetalert";
import { Pagination } from "antd";
import { HrApi, imageApi } from "../../../initialpage/hooks/HrApi";
import useAuth from "../../../initialpage/hooks/useAuth";

// Import CSS
// import "font-awesome/css/font-awesome.min.css";
// import "../../../assets/css/font-awesome.min.css";
// import "../../../assets/css/line-awesome.min.css";
// import "../../../assets/css/select2.min.css";
// import "../../../assets/js/app";

import "../../../assets/css/style.css";

const AllEmployees = () => {
  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [statusType, setStatusType] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [searchEmpAll, setSearchEmpAll] = useState("");
  const [loadUpdate, setLoadUpdate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(24);
  const { searchFunction } = useAuth();

  // Calculate the data for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = allEmployeeData?.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (current, size) => {
    setItemsPerPage(size);
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleStatusType = (e) => {
    let enable = parseInt(e.target.value);
    if (enable === 1) {
      setStatusType(true);
    }
    if (enable === 0) {
      setStatusType(false);
    }
  };

  const searchEmpNameHandler = (e) => {
    const getEmpSeName = e.target.value;
    const empSeName = getEmpSeName.replace(/[^\w ]/g, "");
    setSearchEmpAll(empSeName);
  };

  const handleEnable = (id, name) => {
    swal({
      title: "Are you sure?",
      text: `You are about to enable ${name}`,
      icon: "warning",
      buttons: ["Cancel", "Enable"],
      dangerMode: false,
    }).then((willEnable) => {
      if (willEnable) {
        axios({
          method: "put",
          url: `${HrApi}/hr/emp/putEmployeeStatus`,
          data: {
            ACTIVE: 1,
            EMPLOYE_ID: id,
          },
        });
        swal(`${name} is now enabled`, {
          icon: "success",
        });
        setLoadUpdate(true);
      }
    });
  };

  const handleDisable = (id, name) => {
    swal({
      title: "Are you sure?",
      text: `You are about to disable ${name}`,
      icon: "warning",
      buttons: ["Cancel", "Disable"],
      dangerMode: true,
    }).then((willDisable) => {
      if (willDisable) {
        axios({
          method: "put",
          url: `${HrApi}/hr/emp/putEmployeeStatus`,
          data: {
            ACTIVE: 0,
            EMPLOYE_ID: id,
          },
        });
        swal(`${name} is now disabled`, {
          icon: "success",
        });
        setLoadUpdate(true);
      }
    });
  };

  // Get all employee data
  useEffect(() => {
    const getUsers = () => {
      setAllEmployeeData("");
      setIsLoading(true);
      const url = `${HrApi}/hr/emp/getAllEmp`;
      fetch(url, {
        method: "GET",
      })
        .then((res) => {
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            const empGetData = users?.data;
            const filterData = empGetData.filter(
              (item) => item.ACTIVE === (statusType ? 1 : 0)
            );

            let searchData;
            if (searchEmpAll) {
              searchData = searchFunction(
                filterData,
                searchEmpAll,
                "EMPLOYEE_ID",
                "DEPARTEMENT",
                "DESIGNATION",
                "EMPLOYE_REGISTRATION_NUMBER",
                "MOBILE_PHONE",
                "NAME_ENGLISH"
              );
            } else {
              searchData = filterData;
            }

            setAllEmployeeData(searchData);
            setLoadUpdate(false);
            setIsLoading(false);
          },
          (err) => {
            setHasError(true);
            setIsLoading(false);
          }
        );
    };

    getUsers();
  }, [searchEmpAll, statusType, loadUpdate]);



  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Employee Directory | HR Management</title>
        <meta name="description" content="Employee directory page" />
      </Helmet>

      {/* Header Section */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <div className="row align-items-center px-3 py-4">
            <div className="col">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <div
                    className="buttonColor bg-gradient rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "45px", height: "45px" }}
                  >
                    <i className="fa fa-users text-white fs-4"></i>
                  </div>
                </div>
                <div>
                  <h1 className="page-title mb-0 fs-4 fw-bold text-dark">
                    Employee Directory
                  </h1>
                  {/* <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard" className="text-decoration-none">
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/hr" className="text-decoration-none">
                          HR
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Employee Directory
                      </li>
                    </ol>
                  </nav> */}
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex gap-2">
                <Link
                  to="/hr/allemployeesreports"
                  className="btn btn-danger btn-md border-0 shadow-sm d-flex align-items-center"
                >
                  <i className="fa fa-file-text me-2"></i> Reports
                </Link>
                <Link
                  to="/hr/employeeinformationform"
                  className="btn buttonColor btn-md border-0 shadow-sm d-flex align-items-center"
                >
                  <i className="fa fa-plus me-2"></i> Add Employee
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className="container-fluid">
        <div className="row mt-4 mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <label className="form-label fw-medium mb-2">
                      Search Employees
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0">
                        <i className="fa fa-search text-muted"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Search by name, ID, department..."
                        value={searchEmpAll}
                        onChange={searchEmpNameHandler}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <label className="form-label fw-medium mb-2">
                      Employee Status
                    </label>
                    <select
                      className="form-select"
                      onChange={handleStatusType}
                      defaultValue="1"
                    >
                      <option value="1">Active Employees</option>
                      <option value="0">Inactive Employees</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Grid */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                {isLoading ? (
                  <div className="text-center py-5">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading employee data...</p>
                  </div>
                ) : hasError ? (
                  <div className="text-center py-5">
                    <div className="text-danger mb-3">
                      <i className="fa fa-exclamation-triangle fa-3x"></i>
                    </div>
                    <h4>Error Loading Data</h4>
                    <p className="text-muted">
                      There was a problem retrieving employee information.
                      Please try again later.
                    </p>
                  </div>
                ) : allEmployeeData?.length === 0 ? (
                  <div className="text-center py-5">
                    <div className="text-muted mb-3">
                      <i className="fa fa-search fa-3x"></i>
                    </div>
                    <h4>No Employees Found</h4>
                    <p>No employees match your current search criteria.</p>
                  </div>
                ) : (
                  <div className="row g-4">
                    {currentData.map((employee) => (
                      <div
                        key={employee.EMPLOYEE_ID}
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                      >
                        <div className="position-relative employee-card-wrapper">
                          {/* Premium Glass Effect Card with angled design */}
                          <div
                            className="card h-100 border-0 overflow-hidden employee-card"
                            style={{
                              borderRadius: "16px",

                              backdropFilter: "blur(10px)",
                              boxShadow:
                                "0 10px 30px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {/* Decorative design elements */}
                            <div
                              className="position-absolute"
                              style={{
                                top: 0,
                                right: 0,
                                width: "150px",
                                height: "150px",
                                borderRadius: "0 0 0 100%",
                                background:
                                  "linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(13, 110, 253, 0.1))",
                                zIndex: 0,
                              }}
                            ></div>

                            <div
                              className="position-absolute"
                              style={{
                                bottom: 0,
                                left: 0,
                                width: "100px",
                                height: "100px",
                                borderRadius: "0 100% 0 0",
                                background:
                                  "linear-gradient(45deg, rgba(0, 0, 0, 0.2), rgba(13, 110, 253, 0.05))",
                                zIndex: 0,
                              }}
                            ></div>

                            {/* Card Content */}
                            <div
                              className="card-body position-relative p-0"
                              style={{ zIndex: 1 }}
                            >
                              {/* Status Badge */}
                              <div
                                className="position-absolute"
                                style={{ top: "15px", left: "15px", zIndex: 2 }}
                              >
                                <span
                                  className={`badge ${statusType ? "bg-success" : "bg-danger"
                                    } py-2 px-3 rounded-pill`}
                                >
                                  {statusType ? "Active" : "Inactive"}
                                </span>
                              </div>

                              {/* Action Menu */}
                              <div
                                className="position-relative"
                                style={{ overflow: "visible" }}
                              >
                                <div
                                  className="dropdown position-absolute"
                                  style={{
                                    top: "15px",
                                    right: "15px",
                                    zIndex: 1050,
                                  }}
                                >
                                  <button
                                    className="btn btn-light btn-sm rounded-circle shadow-sm"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <i className="fa fa-ellipsis-v"></i>
                                  </button>

                                  <ul className="dropdown-menu dropdown-menu-right shadow border-0">
                                    {statusType ? (
                                      <li>
                                        <button
                                          className="dropdown-item d-flex align-items-center"
                                          onClick={() =>
                                            handleDisable(
                                              employee.EMPLOYEE_ID,
                                              employee.NAME_ENGLISH
                                            )
                                          }
                                        >
                                          <i className="fa fa-ban me-2 text-danger"></i>{" "}
                                          Disable
                                        </button>
                                      </li>
                                    ) : (
                                      <li>
                                        <button
                                          className="dropdown-item d-flex align-items-center"
                                          onClick={() =>
                                            handleEnable(
                                              employee.EMPLOYEE_ID,
                                              employee.NAME_ENGLISH
                                            )
                                          }
                                        >
                                          <i className="fa fa-check-circle me-2 text-success"></i>{" "}
                                          Enable
                                        </button>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>

                              {/* Profile Section with Avatar */}
                              <div className="text-center p-4">
                                <div className="d-inline-block position-relative">
                                  <div
                                    className="profile-img-container"
                                    style={{
                                      width: "130px",
                                      height: "130px",
                                      margin: "0 auto",
                                      position: "relative",
                                    }}
                                  >
                                    {/* Decorative ring animation */}
                                    <div
                                      className="rotate-animation"
                                      style={{
                                        position: "absolute",
                                        width: "130px",
                                        height: "130px",
                                        borderRadius: "50%",
                                        border: "2px dashed rgb(0, 0, 0)",
                                        top: "0",
                                        left: "0",
                                        animation: "spin 15s linear infinite",
                                      }}
                                    ></div>

                                    {/* Avatar container with border glow effect */}
                                    <div
                                      style={{
                                        width: "110px",
                                        height: "110px",
                                        borderRadius: "50%",
                                        // background:
                                        //   "linear-gradient(to right, #00a49a 0%, #2b3b4e 100%) ",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        margin: "10px auto",
                                        boxShadow:
                                          "0 0 15px rgba(13, 110, 253, 0.5)",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          borderRadius: "50%",
                                          overflow: "hidden",
                                          background: "#fff",
                                        }}
                                      >
                                        {employee.PHOTO_PATH ? (
                                          <img
                                            src={`${imageApi}${employee.PHOTO_PATH}`}
                                            className="w-100 h-100 object-fit-cover"
                                            alt={employee.NAME_ENGLISH}
                                          />
                                        ) : (
                                          <img
                                            src={placeholderImg}
                                            className="w-100 h-100 object-fit-cover"
                                            alt="Employee"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Employee Info */}
                                <div className="mt-4">
                                  <Link
                                    to={`/hr/employeeprofile/${employee.EMPLOYEE_ID}`}
                                    className="text-decoration-none"
                                  >
                                    <h5 className="mb-1 fw-bold text-dark">
                                      {employee.NAME_ENGLISH}
                                    </h5>
                                    <div className="d-flex align-items-center justify-content-center">
                                      <span className="badge bg-primary-subtle text-primary rounded-pill px-3 py-2 mb-2">
                                        {employee.DESIGNATION}
                                      </span>
                                    </div>
                                    <p
                                      className="text-muted small mb-0"
                                      style={{ fontSize: "0.8rem" }}
                                    >
                                      ID: {employee.EMPLOYE_REGISTRATION_NUMBER}
                                    </p>
                                  </Link>
                                </div>
                              </div>

                              {/* Action Buttons - Colorful Gradient */}
                              <div
                                className="p-3 mt-2 text-center"
                                style={{
                                  background:
                                    "linear-gradient(to right, rgba(13, 110, 253, 0.05), rgba(13, 202, 240, 0.1))",
                                }}
                              >
                                <div className="d-flex justify-content-center px-3">
                                  <Link
                                    to={`/hr/employeeprofile/${employee.EMPLOYEE_ID}`}
                                    className="btn btn-primary btn-sm rounded-pill px-3 shadow-sm"
                                    style={{
                                      background:
                                        "#3c50e0",
                                      border: "none",
                                    }}
                                  >
                                    <i className="fa fa-user me-1"></i> Profile
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Add hover glowing effect */}
                          <style jsx>{`
                            .employee-card-wrapper:hover .employee-card {
                              transform: translateY(-5px);
                              box-shadow: 0 15px 30px rgba(13, 110, 253, 0.1),
                                0 5px 15px rgba(0, 0, 0, 0.05);
                            }
                            @keyframes spin {
                              from {
                                transform: rotate(0deg);
                              }
                              to {
                                transform: rotate(360deg);
                              }
                            }
                          `}</style>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Pagination */}
                {!isLoading && allEmployeeData?.length > 0 && (
                  <div className="mt-4 d-flex justify-content-center">
                    <Pagination
                      current={currentPage}
                      pageSize={itemsPerPage}
                      total={allEmployeeData?.length}
                      onChange={handlePageChange}
                      onShowSizeChange={handlePageSizeChange}
                      showSizeChanger
                      pageSizeOptions={["24", "40", "100", "200"]}
                      showTotal={(total, range) => (
                        <span className="fw-medium text-muted">
                          Showing{" "}
                          <span className="fw-bold text-dark">
                            {range[0]}-{range[1]}
                          </span>{" "}
                          of <span className="fw-bold text-dark">{total}</span>{" "}
                          employees
                        </span>
                      )}
                      itemRender={(page, type, originalElement) => {
                        if (type === "prev") {
                          return (
                            <button className="btn btn-sm btn-outline-primary">
                              « Previous
                            </button>
                          );
                        }
                        if (type === "next") {
                          return (
                            <button className="btn btn-sm btn-outline-primary">
                              Next »
                            </button>
                          );
                        }
                        return originalElement;
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEmployees;
